// extracted by mini-css-extract-plugin
export var actionButton = "_9y-0";
export var attachmentLine = "_9y-1";
export var fileInput = "_9y-2";
export var fileUploadWrapper = "_9y-4";
export var footer = "_9y-3";
export var modalContent = "_9y-5";
export var paperclip = "_9y-6";
export var quillEditor = "_9y-7";